module.exports = __webpack_public_path__ + "img/07-avatar male.aa1f7049.png";